// extracted by mini-css-extract-plugin
module.exports = {"primary":"#eb7515","accent":"#e91e63","secondary":"#f0bc13","tertiary":"#b4a734","success":"#f07f13","info":"#2196f3","warning":"#cf4f39","danger":"#fb8c00","error":"#e63838"};